import React from 'react';

import {AlertModal} from 'presentation/components';
import {QueryParamsEnum} from 'presentation/constants';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {AllScheduledActions, AllScheduledDescription} from './AllScheduled';
import {MinimumIntervalActions} from './MinimumInterval/MinimumIntervalActions';
import {MinimumIntervalDescription} from './MinimumInterval/MinimumIntervalDescription';
import {NeedAuthActions, NeedAuthDescription} from './NeedAuth';
import {AlertType, GetAlertActionsParams, TherapyAlertProps} from './types';

const {notice} = translations['pt-br'].privateFlow.therapyBooking.alerts.headerTitle;

function getAlertDescription(alertType: AlertType) {
	if (alertType === 'allScheduled') {
		return <AllScheduledDescription />;
	}
	if (alertType === 'minimumInterval') {
		return <MinimumIntervalDescription />;
	}
	return <NeedAuthDescription />;
}

function getAlertActions({alertType, flowType, handleAction}: GetAlertActionsParams) {
	if (alertType === 'allScheduled') {
		return <AllScheduledActions />;
	}
	if (alertType === 'minimumInterval') {
		return <MinimumIntervalActions handleAction={handleAction} />;
	}
	return <NeedAuthActions flowType={flowType} handleAction={handleAction} />;
}

export function TherapyAlert({
	alertType,
	open,
	setOpen,
	flowType,
	setCalendarOpen,
}: TherapyAlertProps) {
	const setBookingData = useBookingStore(state => state.setBookingData);
	const {setSearchParams} = useQueryParams();

	function handleOpenCalendar() {
		if (setCalendarOpen) {
			setCalendarOpen();
		}
		handleClose();
	}

	function handleClose() {
		setOpen(false);
	}

	function handleAction() {
		if (alertType === 'minimumInterval') {
			handleOpenCalendar();
			return;
		}
		handleClose();

		setBookingData(prev => ({
			...prev,
			dateAt: '',
			hourAt: '',
		}));

		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.CALENDAR_ACTIVE);
			prev.delete(QueryParamsEnum.SHIFT);

			return prev;
		});
	}

	return (
		<AlertModal
			onClose={handleClose}
			open={open}
			variant="info"
			headerTitle={notice}
			subDescription={getAlertDescription(alertType)}
			footerContent={getAlertActions({
				alertType,
				handleAction,
				flowType,
			})}
		/>
	);
}
